import { FetchingKeys, Item, QueuePoolReducer } from "./types";

export const UPDATE_QUEUE_LIST = "UPDATE_QUEUE_LIST";
export const UPDATE_FETCHING_KEYS = "UPDATE_FETCHING_KEYS";

export interface UpdateQueueListAction {
  type: typeof UPDATE_QUEUE_LIST;
  payload: { userId: number; queueName: string; list: Item[] };
}

export interface UpdateFetchingKeysAction {
  type: typeof UPDATE_FETCHING_KEYS;
  payload: { queueName: string; fetchingKeys: FetchingKeys };
}

export type FetchQueueActionTypes = UpdateQueueListAction | UpdateFetchingKeysAction;

const initialState: QueuePoolReducer = {
  fetchingKeys: {},
  queuePool: {},
};

export function fetchQueueReducer(state = initialState, action: FetchQueueActionTypes): QueuePoolReducer {
  if (action.type === UPDATE_QUEUE_LIST) {
    const { userId, queueName, list } = action.payload;
    const queuePool = {
      ...state.queuePool,
      [userId]: { ...state.queuePool[userId], [queueName]: [...list] },
    };

    return {
      ...state,
      queuePool,
    };
  }

  if (action.type === UPDATE_FETCHING_KEYS) {
    const { queueName, fetchingKeys: keys } = action.payload;
    const fetchingKeys = {
      ...state.fetchingKeys,
      [queueName]: { ...keys },
    };

    return {
      ...state,
      fetchingKeys,
    };
  }

  return state;
}
